/**
 * Canonical CRM classification vocabularies — frontend mirror.
 *
 * MIRRORS backend/crm/vocabularies.py. Do not edit one without the other:
 * backend/crm/tests_vocabulary_parity.py parses THIS file and fails the test
 * suite the moment the two lists disagree.
 *
 * Consumed by the CRM Partner Profile tab and by the KYC onboarding form so a
 * partner ticks the same boxes HMS stores. Order is the render order.
 */

// CRMProfile.partner_type_selections
export const PARTNER_TYPE_OPTIONS = [
    'Buyer (Debtor)',
    'Seller (Creditor)',
    'Consumer',
    'Producer',
    'Service provider',
    'End User',
    'Ship Owners',
    'Charterer',
    'Brokers',
    'Governmental',
    'Non-governmental',
    'Parastatal',
    'Supplier Lubricants',
    // An HMS colleague held as a partner (HR -> Create Partner).
    'Employee',
];

// The external KYC onboarding form asks a company what it is; "Employee" is
// only ever set by HR on our own colleague's record, never self-declared.
export const KYC_PARTNER_TYPE_OPTIONS = PARTNER_TYPE_OPTIONS.filter((t) => t !== 'Employee');

// CRMProfile.industry_selections
export const INDUSTRY_OPTIONS = [
    'Agri',
    'Bank',
    'Cement',
    'Freight',
    'Insurance',
    'IT',
    'Labor',
    'Metals',
    'Office Expenses',
    'Power Generation',
    'Steel',
    'Stock & Sale',
    'Stock monitoring',
    'Travel Expenses',
    'Various',
];

// CRMProfile.creditor_debtor_selections — both may be held at once.
export const CREDITOR_DEBTOR_OPTIONS = [
    'Creditor',
    'Debtor',
];

// CRMProfile.partner_subcategory_selections
export const PARTNER_SUBCATEGORY_OPTIONS = [
    'Bulker',
    'Bunker Trader',
    'Container',
    'Cruise Ships',
    'Dredger',
    'Ferries',
    'Fishing',
    'Gas Carriers',
    'General Cargo',
    'Industrial',
    'Large/Commodity Trader',
    'Luxury Yacht',
    'Major',
    'NOC',
    'Naval',
    'Offshore',
    'Physical',
    'RO/RO',
    'Reefer',
    'Research',
    'Shore Tank',
    'Surveyor',
    'Tanker',
    'Tanker - Chemical',
    'Tugs',
];

const SPLIT_PATTERN = /[,/;|\n]/;

/**
 * Normalise a stored value to { matched, unmatched } against a vocabulary.
 *
 * Mirrors coerce_to_vocabulary() in the Python module. The string branch is
 * what rescues KYC cases answered before these fields became tickboxes:
 * "Supplier / Service Provider" auto-ticks "Service provider" and hands back
 * "Supplier" so the partner can see what we could not place, rather than the
 * answer silently reading as blank.
 */
export const coerceToVocabulary = (value, options) => {
    if (value === null || value === undefined) return { matched: [], unmatched: [] };

    const tokens = Array.isArray(value)
        ? value.map((v) => String(v).trim())
        : String(value).split(SPLIT_PATTERN).map((v) => v.trim());

    const lookup = new Map(options.map((o) => [o.toLowerCase(), o]));
    const matched = [];
    const unmatched = [];
    tokens.forEach((token) => {
        if (!token) return;
        const canonical = lookup.get(token.toLowerCase());
        if (!canonical) {
            if (!unmatched.includes(token)) unmatched.push(token);
        } else if (!matched.includes(canonical)) {
            matched.push(canonical);
        }
    });

    matched.sort((a, b) => options.indexOf(a) - options.indexOf(b));
    return { matched, unmatched };
};
